import { useMemo } from 'react'

export const useHeaderContent = ({
  headerData,
  headerOverride,
  region
}: {
  headerData: any
  headerOverride?: any
  region: any
}) =>
  useMemo(() => {
    if (headerOverride?.pageHeader) {
      return headerOverride.pageHeader.find((f: any) => f.country === region)
    }
    // add a check for headerData for the first render
    return headerData?.find((f: any) => f?.country === region)
  }, [headerData, headerOverride, region])

export const useFooterContent = ({
  footerData,
  footerOverride,
  region
}: {
  footerData: any
  footerOverride?: any
  region?: any
}) =>
  useMemo(() => {
    if (footerOverride) {
      return footerOverride?.pageFooter.find((f: any) => f.country === region)
        ?.footerContent
    }
    // add a check for footerData for the first render
    return footerData?.find((f: any) => f.country === region)?.footerContent
  }, [footerData, footerOverride, region])

export const useGlobalSettings = ({
  globalSettingsData,
  locale,
  region
}: {
  globalSettingsData: any
  locale?: string
  region?: string
}) =>
  useMemo(() => {
    if (!globalSettingsData?.length) {
      return globalSettingsData?.[0] // fallback to first item if no array
    }

    // First try to find exact locale match
    const exactMatch = globalSettingsData.find(
      (settings: any) => settings.node_locale === locale
    )
    if (exactMatch) return exactMatch

    // Fallback to region-based matching (e.g., 'en' for 'en-US', 'en-GB', etc.)
    const languageCode = locale?.split('-')[0] || 'en'
    const languageMatch = globalSettingsData.find((settings: any) =>
      settings.node_locale?.startsWith(languageCode)
    )
    if (languageMatch) return languageMatch

    // Final fallback to US English
    const defaultMatch = globalSettingsData.find(
      (settings: any) =>
        settings.node_locale === 'en-US' || settings.node_locale === 'en'
    )
    if (defaultMatch) return defaultMatch

    // Ultimate fallback to first available
    return globalSettingsData[0]
  }, [globalSettingsData, locale, region])
